import { Api } from '../../Utils/api'
import { CaixaRelatorio, DadosCaixaRelatorio, error99, RetAPI } from '../../Utils/Types'

export const CaixaService = {

    ConsultarCaixa: async (relatorio: DadosCaixaRelatorio): Promise<RetAPI> => {

        const resp = await Api('CaixaDiario/Relatorio', 'get', {
            data: relatorio?.data,
            id_vendedor: relatorio?.id_vendedor,
        })
        const attributes: CaixaRelatorio[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes  // o data fica []
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                const caixaRelatorio: CaixaRelatorio = {

                    resumo_vendas: Array.isArray(resp.data.resumo_vendas) ?
                        resp.data.resumo_vendas.map((venda: any) => ({
                            valor: venda.valor,
                            descricao: venda.descricao,
                            tipo: venda.tipo
                        })) : [],

                    resumo_recebimento: Array.isArray(resp.data.resumo_recebimento) ?
                        resp.data.resumo_recebimento.map((recebimento: any) => ({
                            valor: recebimento.valor,
                            descricao: recebimento.descricao,
                            tipo: recebimento.tipo
                        })) : [],

                    tot_suprimento: (resp.data?.tot_suprimento || 0),
                    tot_sangria: (resp.data?.tot_sangria || 0),

                    sup_sangrias_list: Array.isArray(resp.data.sup_sangrias_list) ?
                        resp.data.sup_sangrias_list.map((sangria: any) => ({
                            observacao: sangria.observacao,
                            dh_insert: sangria.dh_insert,
                            valor: sangria.valor,
                            tipo: sangria.tipo
                        })) : [],

                    empresa: {
                        razao: resp.data?.dados_empresa?.razao,
                        nome_fantasia: resp.data?.dados_empresa?.nome_fantasia,
                        bairro: resp.data?.dados_empresa?.bairro,
                        endereco: resp.data?.dados_empresa?.endereco,
                        numero: resp.data?.dados_empresa?.numero,
                        cep: resp.data?.dados_empresa?.cep,
                        complemento: resp.data?.dados_empresa?.complemento,
                        cnpj_cpf: resp.data?.dados_empresa?.cnpj_cpf,
                        ie_rg: resp.data?.dados_empresa?.ie_rg,
                        cidade: resp.data?.dados_empresa?.cidade,
                        uf: resp.data?.dados_empresa?.uf,
                    }
                }

                attributes.push(caixaRelatorio)
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes // o data fica []
            } 
        }

        return {
            error: false,
            data: attributes 
        }
    }
}